import { http } from '@/utils/http';
import qs from 'qs';

// 获取当前排行榜
export function getRankList(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=rank-list');
}
// 获取获奖排行榜
export function getPrizeList(voteName: string, data: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=prize-list&type=' + data,
  );
}
// 获取明细列表接口
export function getDetailList(voteName: string, data: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=detail-list&time=' + data,
  );
}
// 是否展示兑奖接口
export function ifPrize(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=if-prize');
}
// 报名页面提交报名接口
export function save(voteName: string, data: any) {
  const qsData = qs.stringify(data);
  return http.post('/vote/' + voteName + '/controller.php?enews=save', qsData);
}
// 报名页面提交报名接口
export function prizeSave(voteName: string, data: any) {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=prize-save',
    qsData,
  );
}
